import { render, staticRenderFns } from "./ListPaymentTermPage.vue?vue&type=template&id=2d12ff0b"
import script from "./ListPaymentTermPage.vue?vue&type=script&lang=js"
export * from "./ListPaymentTermPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports